export default "__VITE_ASSET__DF8CPXy3__"